import { render, staticRenderFns } from "./order-invoice.vue?vue&type=template&id=215ca44a&scoped=true"
import script from "./order-invoice.vue?vue&type=script&lang=js"
export * from "./order-invoice.vue?vue&type=script&lang=js"
import style0 from "./order-invoice.vue?vue&type=style&index=0&id=215ca44a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ca44a",
  null
  
)

export default component.exports